import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { Button } from "@finora/ui";
import { api } from "../../lib/api";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const mutation = useMutation({
    mutationFn: () => api.forgotPassword({ email }),
  });

  if (mutation.isSuccess) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-app-bg px-4 py-10">
        <div className="w-full max-w-md rounded-xl border border-border bg-surface p-8 text-center shadow-subtle">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-brand-light text-brand">
            <MailCheck className="h-7 w-7" />
          </div>
          <h1 className="mb-2 text-xl font-semibold text-slate-900">Proverite email</h1>
          <p className="text-sm text-slate-500">{mutation.data.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-app-bg px-4 py-10">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          mutation.mutate();
        }}
        className="w-full max-w-md rounded-xl border border-border bg-surface p-6 shadow-subtle"
      >
        <h1 className="mb-1 text-xl font-semibold text-slate-900">Zaboravili ste lozinku?</h1>
        <p className="mb-6 text-sm text-slate-500">Unesite email - poslaćemo vam link za resetovanje lozinke.</p>

        <div className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-10 w-full rounded-lg border border-border px-3 text-sm focus:border-brand focus:outline-none"
              required
            />
          </div>

          <Button type="submit" className="w-full" disabled={mutation.isPending}>
            {mutation.isPending ? "Šaljem..." : "Pošalji link"}
          </Button>

          <p className="text-center text-sm text-slate-500">
            <Link to="/prijava" className="text-brand hover:underline">
              Nazad na prijavu
            </Link>
          </p>
        </div>
      </form>
    </div>
  );
}
